<ui-modal [title]="poolMode() ? 'Zum Pool hinzufügen' : 'Mahlzeit hinzufügen'" size="md">
  @if (target() || poolMode()) {
    @if (poolMode()) {
      <p class="mb-3 text-sm text-base-content/60">Als Vorschlag in den Pool – später in einen Tag ziehen.</p>
    } @else {
      <p class="mb-3 text-sm text-base-content/60">{{ dateLabel }} · {{ slotLabel }}</p>
    }

    <!-- Generate with the assistant: just opens the global dialog chat -->
    <button
      type="button"
      class="btn btn-outline btn-primary btn-sm mb-3 w-full justify-start gap-2"
      (click)="openAssistant()"
    >
      <fa-icon [icon]="faWandMagicSparkles"></fa-icon>
      Mit Assistent erstellen
    </button>

    <!-- Quick-pick from the pool: schedule an existing idea without searching.
         Cell mode only — pooling from the pool makes no sense. -->
    @if (!poolMode() && pool().length > 0) {
      <div class="mb-3">
        <label class="mb-1 block text-xs font-medium text-base-content/60">Aus dem Pool</label>
        <ul class="menu w-full p-0">
          @for (p of pool(); track p.clientId ?? p.id) {
            <li>
              <button
                type="button"
                class="flex items-center justify-between"
                [disabled]="p.pending || p.failed"
                (click)="choosePoolItem(p)"
              >
                <span class="truncate">{{ p.title }}</span>
                @if (p.servings != null) {
                  <span class="shrink-0 text-xs text-base-content/50">{{ p.servings }} Port.</span>
                }
              </button>
            </li>
          }
        </ul>
      </div>
      <div class="mb-3 border-t border-base-300"></div>
    }

    <!-- Recipe search -->
    <ui-input
      type="search"
      [value]="query()"
      placeholder="Rezept suchen…"
      [fullWidth]="true"
      [clearable]="true"
      ariaLabel="Rezept suchen"
      (valueChange)="onQueryChange($event)"
    ></ui-input>

    <div class="mt-2 max-h-72 overflow-y-auto">
      @if (searching()) {
        <div class="flex items-center gap-2 px-1 py-3 text-sm text-base-content/60">
          <span class="loading loading-spinner loading-xs"></span> Suche…
        </div>
      } @else if (results().length === 0) {
        <div class="px-1 py-3 text-sm text-base-content/50">Keine Rezepte gefunden.</div>
      } @else {
        <ul class="menu w-full p-0">
          @for (r of results(); track r.id) {
            <li>
              <button type="button" class="flex items-center justify-between" (click)="chooseRecipe(r)">
                <span class="truncate">{{ r.title }}</span>
                <span class="shrink-0 text-xs text-base-content/50">{{ r.servings }} Port.</span>
              </button>
            </li>
          }
        </ul>
      }
    </div>

    <!-- Free-text escape hatch -->
    <div class="mt-4 border-t border-base-300 pt-3">
      <label class="mb-1 block text-xs font-medium text-base-content/60">Oder frei eingeben</label>
      <div class="flex items-center gap-2">
        <input
          type="text"
          class="input input-bordered input-sm w-full"
          placeholder="z. B. Auswärts essen"
          [(ngModel)]="freeText"
          (keydown.enter)="chooseFreeText()"
          [attr.aria-label]="'Freitext-Eintrag'"
        />
        <button type="button" class="btn btn-sm btn-primary" [disabled]="!freeText.trim()" (click)="chooseFreeText()">
          Hinzufügen
        </button>
      </div>
    </div>
  }
</ui-modal>
